import styled from 'styled-components';

export const RebrandImageUploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border-radius: 6px;
  background-color: var(--color-gray-10);
  grid-column: 2 / span 3;
  padding: 22px 61.5px;
`;

export const RebrandImageUploaderHeader = styled.div<{ hasHeader?: boolean }>`
  margin-top: var(--sizes-30);
  margin-bottom: ${({ hasHeader }) => (hasHeader ? `var(--sizes-0)` : `var(--sizes-40)`)};
  color: var(--color-gray-90);
  font-size: var(--typography-regular-14pt-semibold-font-size);
  font-weight: var(--typography-regular-14pt-semibold-font-weight);
`;

export const RebrandImageUploaderMessage = styled.p<{ hasHeader?: boolean }>`
  margin-top: ${({ hasHeader }) => (hasHeader ? `var(--sizes-30)` : `var(--sizes-40)`)};
  margin-bottom: var(--sizes-40);
  color: var(--color-gray-70);
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.005em;
  font-weight: var(--typography-small-13pt-normal-font-weight);
  white-space: pre-wrap;
`;

export const RebrandUploadButton = styled.button`
  display: block;
  background: none;
  color: var(--color-brand-secondary-sapphire);
  font: var(--font-regular-14pt-normal);
  font-weight: var(--typography-small-13pt-semibold-font-weight);
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 2 / span 3;
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 24px;
`;

export const ButtonContainer = styled.div`
  margin-top: 16px;
`;

export const Image = styled.div`
  position: relative;
  width: 115px;
  height: 115px;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    border-radius: 6px;
    transition: background 0.5s ease;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    border-radius: 6px;
  }

  &:hover .overlay {
    display: block;
    background: rgba(0, 0, 0, 0.5);
  }

  .button-container {
    background: #ffffff;
    position: absolute;
    width: 27.34px;
    height: 27.34px;
    left: 43.43px;
    top: 44.23px;
    opacity: 0;
    transition: opacity 0.35s ease;
    border-radius: 50%;
  }

  &:hover .button-container {
    opacity: 1;
  }
`;
